import { takeLatest, put, call } from 'redux-saga/effects';
import axios from 'app/services/http/axios';

// -------

import { PublicApi } from 'modules/Public';
import {
  signOutRequest,
  signOutSuccess,
} from 'modules/Public/SignIn/store/slice';

// -------

function* signOut({ payload }) {
  console.log('SIGNOUT >>>>>, REQUEST TO BACKEND', payload)
  yield put(signOutSuccess());
}

// -------

export function* watchSignOutSaga() {
  yield takeLatest(signOutRequest.type, signOut)
}

export default watchSignOutSaga
